module.exports = __webpack_public_path__ + "img/xqimg6.e673af7a.png";